import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    carouselExternalControls: 'flex gap-1 <lg:hidden',
    carouselExternalControlsColor: '@hactive:bg-brand-1/10',
    carouselControls: 'mx-6 b b-white rounded-full bg-white/75 flex h-11 w-11 shadow-sm center backdrop-blur-xs',
  },
  carouselAlign: 'start',
  carouselArrows: 'lgNoTitle',
  carouselLoop: true
} satisfies RecursivePartial<CMSConfig['articleCarousel']>
